var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.125,
    cy: 14,
    r: 14,
    fill: "#DCEFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0258 16.2035L13.5918 14.9375V10.6875H13.9918V14.6595L17.1638 15.8295L17.0258 16.2035Z",
    fill: "#004C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7925 6.98047C11.9105 6.98047 10.1045 7.75047 8.79446 9.07847L8.67646 7.60647L7.48046 7.70247L7.76646 11.2865L7.97846 11.2485L10.2185 10.8405L11.3265 10.6385L11.1105 9.45847L9.90246 9.67847C10.9625 8.72647 12.3505 8.18047 13.7925 8.18047C17.0005 8.18047 19.6125 10.7925 19.6125 14.0005C19.6125 17.2085 17.0005 19.8205 13.7925 19.8205C10.5845 19.8205 7.97246 17.2085 7.97246 14.0005C7.97246 13.5405 8.02646 13.0825 8.13446 12.6385L7.44046 13.1645L6.96246 12.3805C6.83646 12.9085 6.77246 13.4525 6.77246 14.0005C6.77246 17.8705 9.92246 21.0205 13.7925 21.0205C17.6625 21.0205 20.8125 17.8705 20.8125 14.0005C20.8125 10.1305 17.6625 6.98047 13.7925 6.98047Z",
    fill: "#004C3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/Orders.a8f23fc10617f56fb5048ee15af4509e.svg";
export { ForwardRef as ReactComponent };